import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyDn3pRz0GbfZvy1u0DCBrXjqZHvhpCiqQM',
  authDomain: 'computales.firebaseapp.com',
  databaseURL: 'https://computales.firebaseio.com',
  projectId: 'computales',
  storageBucket: 'computales.appspot.com',
  messagingSenderId: '631314136619',
  appId: '1:631314136619:web:0dccc25e6bbe06d886f46e'
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
